import React from "react";
import { Link, useLocation } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Abonnement" },
  { to: "/contact-us", label: "Joignez-nous" },
];

// Logo and the two public links, over whatever background the page has
const TopBar = () => {
  const { pathname } = useLocation();

  return (
    <header className="relative mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-3 sm:px-6 sm:py-4">
      <Link to="/" aria-label="Accueil">
        <img
          src={`${process.env.PUBLIC_URL}/logo_sutton_encore.webp`}
          width="120"
          height="80"
          alt="Sutton Encore"
          className="h-14 w-auto sm:h-20"
        />
      </Link>
      <nav className="flex gap-5 sm:gap-8">
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`text-sm font-semibold uppercase tracking-wider hover:text-white ${
              pathname === link.to ? "text-yellow-500" : "text-gray-200"
            }`}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </header>
  );
};

export default TopBar;
